var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { P, CustomElement, Defaults, ViewChild } from '@pacem/pacem-core';
import { PacemTextualInputElement } from './input';
//namespace Pacem.Components.Scaffolding {
let PacemHiddenInputElement = class PacemHiddenInputElement extends PacemTextualInputElement {
    constructor() {
        super();
    }
    toggleReadonlyView(readonly) { }
    get inputFields() {
        return [this.input];
    }
};
__decorate([
    ViewChild('input[type=hidden]')
], PacemHiddenInputElement.prototype, "input", void 0);
PacemHiddenInputElement = __decorate([
    CustomElement({ tagName: P + '-input-hidden', template: '<input type="hidden" />', shadow: Defaults.USE_SHADOW_ROOT })
], PacemHiddenInputElement);
export { PacemHiddenInputElement };
